// ============================================
// Status enums for collections
// ============================================

export const LEAD_STATUS = {
  NEW: 'new',
  CONTACTED: 'contacted',
  CONVERTED: 'converted',
  DISMISSED: 'dismissed',
};

export const ESTIMATE_REQUEST_STATUS = {
  NEW: 'new',
  SCHEDULED_VISIT: 'scheduled-visit',
  ESTIMATE_SENT: 'estimate-sent',
  APPROVED: 'approved',
  DECLINED: 'declined',
  DISMISSED: 'dismissed',
};

export const ESTIMATE_STATUS = {
  DRAFT: 'draft',
  SENT: 'sent',
  APPROVED: 'approved',
  DECLINED: 'declined',
  EXPIRED: 'expired',
};

export const JOB_STATUS = {
  SCHEDULED: 'scheduled',
  IN_PROGRESS: 'in-progress',
  COMPLETED: 'completed',
  INVOICED: 'invoiced',
  PAID: 'paid',
  CANCELLED: 'cancelled',
};

export const JOB_TYPE = {
  HOURLY: 'hourly',
  FLAT_RATE: 'flat-rate',
};

export const INVOICE_STATUS = {
  DRAFT: 'draft',
  SENT: 'sent',
  PAID: 'paid',
  OVERDUE: 'overdue',
  VOID: 'void',
};

export const EMPLOYEE_ROLE = {
  TECH: 'tech',
  ADMIN: 'admin',
  OFFICE: 'office',
};

export const PROPERTY_CLIENT_ROLE = {
  OWNER: 'owner',
  TENANT: 'tenant',
  PROPERTY_MANAGER: 'property-manager',
  SPOUSE: 'spouse',
  OTHER: 'other',
};

export const PAYMENT_METHOD = {
  STRIPE_TERMINAL: 'stripe-terminal',
  SQUARE: 'square',
  CASH: 'cash',
  CHECK: 'check',
  ZELLE: 'zelle',
  OTHER: 'other',
};
